import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { FilterSelection } from '../filters/filter-selection';
import { getStoredFilter } from '../filters/filter-common';

const getValue = (data, field, filterParams) => {
  const metadata = data.metadata;
  if (metadata) {
    return metadata[filterParams.attribute.name]?.value
      ? metadata[filterParams.attribute.name].value
      : metadata[filterParams.attribute.name]?.item.value;
  }
};

// eslint-disable-next-line react/display-name
export const metadataGridFilter = forwardRef((props, ref) => {
  const [filterKey, setFilterKey] = useState(props.colDef.colId);
  const [columnField, setColumnField] = useState(undefined);
  const [componentKey, setComponentKey] = useState(Math.random());

  useImperativeHandle(ref, () => {
    return {
      doesFilterPass(params) {
        const filter = getStoredFilter(filterKey);
        if (!filter) {
          return true;
        }

        if (filter.allSelected) {
          return true;
        }

        const rowValue = getValue(params.data, columnField, props.colDef.filterParams);
        if (rowValue) {
          for (const selection of filter.items) {
            if (selection.selected && selection.lcValue === rowValue.toLowerCase()) {
              return true;
            }
          }
        }
        return false;
      },

      isFilterActive() {
        const filter = getStoredFilter(props.colDef.colId);
        if (!filter) {
          return false;
        }
        return !filter.allSelected;
      },

      setModel(_model) {
        setComponentKey(Math.random());
      },
    };
  });

  const filterChanged = () => {
    props.filterChangedCallback();
  };

  useEffect(() => {
    props.filterChangedCallback();
  }, []);

  useEffect(() => {
    setColumnField(props.colDef.field);
    setFilterKey(props.colDef.colId);
  }, []);

  return (
    <div>
      {filterKey && <FilterSelection key={componentKey} filterId={filterKey} filterChangedCallback={filterChanged} />}
    </div>
  );
});
